import { Injectable, NgZone } from '@angular/core';
import { fromEvent, Observable } from 'rxjs';
import { map, throttleTime } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class VisibilityService {
  constructor(private ngZone: NgZone) {}

  getVisibilityChange(delayInMs?: number): Observable<boolean> {
    return this.ngZone.runOutsideAngular(() => {
      return fromEvent(document, 'visibilitychange').pipe(
        throttleTime(delayInMs ?? 200), // Use the passed-in delay
        map(() => !document.hidden)
      );
    });
  }
}
